module.exports = __webpack_public_path__ + "img/9788993094671.16e19419.jpg";